























































































import { Component, Prop, Vue } from 'vue-property-decorator'

import { changeRole, uploadAvatar } from '@/apis/myInfo/myInfo.ts'

import { Dialog } from 'vant'
import { UserInfo } from '@/interfaces/vuexStateInterface'
import i18n from '@/lang';
@Component({})
export default class MyInfoDetail extends Vue {
  private show: boolean = false
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo
  }
  private columns: Array<string> = [i18n.t('ktpMy.学生') as string, i18n.t('ktpMy.老师') as string]
  private teacherInfoDetail = [
    {
      text: i18n.t('ktpMy.头像'),
      info: this.userInfo.avatar,
      routerQuery: 'avatar',
    },
    {
      text: i18n.t('Home.姓名'),
      info: this.userInfo.username,
      routerQuery: 'name',
    },
    {
      text: i18n.t('ktpMy.教工号'),
      info: this.userInfo.stno,
      routerQuery: 'stno',
    },
    {
      text: i18n.t('Home.学校'),
      info: this.userInfo.school,
      routerQuery: 'school',
    },
    {
      text: i18n.t('ktpMy.身份'),
      info: this.userInfo.usertype,
      routerQuery: 'identity',
    },
    {
      text: i18n.t('ktpMy.院系'),
      info: this.userInfo.department,
      routerQuery: 'depart',
    },
    {
      text: i18n.t('ktpMy.所授课程'),
      info: this.userInfo.teachcourse,
      routerQuery: 'lesson',
    },
    {
      text: i18n.t('ktpMy.专业'),
      info: this.userInfo.majors,
      routerQuery: 'major',
    },
  ]

  private studentInfoDetail = [
    {
      text: i18n.t('ktpMy.头像'),
      info: this.userInfo.avatar,
      routerQuery: 'avatar',
    },
    {
      text: i18n.t('Home.姓名'),
      info: this.userInfo.username,
      routerQuery: 'name',
    },
    {
      text: i18n.t('Home.学号'),
      info: this.userInfo.stno,
      routerQuery: 'stno',
    },
    {
      text: i18n.t('Home.学校'),
      info: this.userInfo.school,
      routerQuery: 'school',
    },
    {
      text: i18n.t('ktpMy.身份'),
      info: this.userInfo.usertype,
      routerQuery: 'identity',
    },
    {
      text: i18n.t('CourseHome.年级'),
      info: '',
      routerQuery: 'grade',
    },
    {
      text: i18n.t('CourseHome.班级'),
      info: '',
      routerQuery: 'class',
    },
    {
      text: i18n.t('CourseHome.入学时间'),
      info: '',
      routerQuery: 'interSchoolTime',
    },
    {
      text: i18n.t('ktpMy.院系'),
      info: this.userInfo.department,
      routerQuery: 'depart',
    },
    {
      text: i18n.t('ktpMy.专业'),
      info: this.userInfo.majors,
      routerQuery: 'major',
    },
  ]

  constructor() {
    super()
  }

  upload() {
    // uploadAvatar()
    //   .then((res) => {})
    //   .catch((err) => {})
    this.$router.push('/avatar')
  }

  goSetInfo(index: number) {
    if (this.userInfo.usertype == '1') {
      if (this.teacherInfoDetail[index].routerQuery == 'avatar') {
        return
      } else if (this.teacherInfoDetail[index].routerQuery == 'identity') {
        // if(this.userInfo.isvip != "0"){
        //   return
        // }else{
        //   this.show = true
        // }
        this.show = true
      } else {
        this.$router.push({ path: '/infoModify', query: { modify: this.teacherInfoDetail[index].routerQuery } })
      }
    } else {
      if (this.studentInfoDetail[index].routerQuery == 'avatar') {
        return
      } else if (this.studentInfoDetail[index].routerQuery == 'identity') {
        if(this.userInfo.isvip != "0"){
          Dialog.alert({
            title: i18n.t('Common.提示') as string,
            message: i18n.t('CommonComponents.Vipdg.您当时是学生VIP无法转换成老师身份如有特殊需要请联系客服进行修改') as string,
          }).then(() => {
            // on close
          });
          return
        }else{
        this.show = true
        }
      } else {
        this.$router.push({ path: '/infoModify', query: { modify: this.studentInfoDetail[index].routerQuery } })
      }
    }
  }

  // 转换身份确定
  onConfirm(value: string, index: number) {
    this.show = false
    changeRole({ role: index })
      .then(() => {
        this.$store.dispatch('setUserInfo').then(() => {
          this.$router.go(0)
        })
      })
      .catch(() => {})
  }
  onCancel() {
    this.show = false
  }
  created() {
    // this.userInfo = this.$store.state.userInfo
    this.$setNavInfo({
      type: 'normal',
      title: i18n.t('ktpMy.个人资料') as string,
      showTitle: true,
      backConfig: () => {
        this.$router.push('/ktpMy')
      },
    })
  }

  mounted() {
    if (this.userInfo.additionInfo) {
      this.studentInfoDetail.forEach((item) => {
        if (item.text === i18n.t('CourseHome.年级')) {
          item.info = this.userInfo!.additionInfo!.grade || ''
        }
        if (item.text === i18n.t('CourseHome.班级')) {
          item.info = this.userInfo!.additionInfo!.classno || ''
        }
        if (item.text === i18n.t('CourseHome.入学时间')) {
          item.info = this.userInfo!.additionInfo!.enrolltime || ''
        }
      })
    }
  }
  // this.$router.go(0)

  // 上传图片之前
  beforeRead(file: any) {
    this.$toast(i18n.t('ktpMy.图片正在插入中'))
    if (file.type.indexOf('image') === -1) {
      this.$toast(i18n.t('ktpMy.请选择图片格式的文件'))
      return false
    }

    if(file.size > 5242880) {
      this.$toast(i18n.t('ktpMy.图片最大不能超过5MB'));
      return false;
    }
    return true
  }
  // 上传图片之后
  afterRead(file: any) {
    sessionStorage.headImg = file.content
    this.$router.push({
      path: '/avatar',
    })
  }
}
